import Accordion from 'components/Accordion';
import DetailsViewEntityLink from 'components/DetailsViewEntityLink';
import DetailsViewEntityLinkContainer from 'components/DetailsViewEntityLinkContainer';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

const LinkedEntitiesAccordion: FunctionComponent<Props> = ({
    children,
    entitiesLink = [],
    isOpen,
    label,
    onToggle,
    testId = TEST_ID
}) => (
    <Accordion isOpen={isOpen} label={label} onToggle={onToggle} testId={testId}>
        <DetailsViewEntityLinkContainer>
            {entitiesLink.map(({ entityName, entityRoute, entityType }) => (
                <DetailsViewEntityLink
                    entityName={entityName}
                    entityRoute={entityRoute}
                    entityType={entityType}
                    key={entityRoute ?? entityType}
                />
            ))}

            {children}
        </DetailsViewEntityLinkContainer>
    </Accordion>
);

export default LinkedEntitiesAccordion;
